// zh.js — auto-generated translation. Source: ./en.js
const zh = {
  meta: {
    backToHome: "回到主页",
    lastUpdated: "最后更新：2026年4月8日",
  },

  mentionsLegales: {
    title: "法律声明",
    seoTitle: "法律声明 | Lumina Wallet",
    seoDescription: "Lumina Wallet 法律声明。关于网站发布者、托管服务和法律义务的信息。",
    body: `## 1. 网站发布者

根据2004年6月21日法国第2004-575号《数字经济信心法》(LCEN)第六条，luminawallet.org网站用户被告知参与其创建和监控的各方身份：

- **公司名称：** HEDONISME SARL
- **法律形式：** 有限责任公司 (SARL)
- **股本：** 64 000,00 欧元
- **注册地址：** 933 Route Departementale, Zone Artisanale la Houblonniere, 59270 Meteren, France
- **注册号：** RCS Dunkerque 901 439 505
- **注册日期：** 2021年7月15日
- **欧盟共同体增值税号：** FR43 901 439 505
- **经营活动：** 商业及其他管理咨询活动 — NAF/APE 代码：70.22Z
- **出版总监：** Stéphane Anthoniak, HEDONISME SARL经理
- **联系邮箱：** support@luminawallet.org
- **网站：** https://luminawallet.org

## 2. 托管服务提供商

luminawallet.org网站由以下公司托管：

- **公司名称：** Vercel Inc.
- **地址：** 440 N Barranca Ave #4133, Covina, CA 91723, United States
- **联系方式：** privacy@vercel.com

本网站由 Vercel 托管。已采取技术、组织和合同层面的措施以规范与托管相关的数据处理。单凭使用托管服务提供商并不能确保整体符合 GDPR 的要求。

## 3. 知识产权

luminawallet.org网站和Lumina Wallet应用程序上出现的所有内容，包括但不限于图形、图像、文本、视频、动画、声音、标识、GIF和图标，以及其格式，均为HEDONISME SARL的专有财产，但属于其他合作公司或作者的商标、标识或内容除外。

未经HEDONISME SARL明确书面同意，严禁以任何方式复制、分发、修改、改编、再传播或出版这些不同元素的任何部分。任何此类展示或复制，无论通过何种方式，均构成法国《知识产权法》第L.335-2条及后续条款所处罚的侵权行为。

## 4. 责任限制

HEDONISME SARL致力于在luminawallet.org网站上提供尽可能准确的信息。然而，本公司不对因自身或提供信息的第三方合作伙伴造成的遗漏、不准确和更新不足承担责任。

网站上显示的所有信息仅供参考，并可能发生变化。此外，网站上的信息并非详尽无遗。

**风险提示：** 加密货币是高度波动的资产。其价值可能大幅波动。投资加密货币涉及高资本损失风险。Lumina Wallet严格来说是一款非托管软件管理工具，不提供金融、法律或投资建议。用户对其投资决策以及其私钥/恢复短语的安全性负全责。

## 5. 个人数据保护 (GDPR)

在法国，个人数据主要受1978年1月6日第78-87号法律、2004年8月6日第2004-801号法律、《刑法典》第L. 226-13条以及1995年10月24日欧洲指令 (GDPR) 的保护。

有关我们如何收集、使用和保护您的数据的更多信息，请查阅我们的《隐私政策》。

## 6. 超文本链接和Cookie

luminawallet.org网站可能包含一些超文本链接到其他网站，这些链接是在HEDONISME SARL授权下设置的。然而，HEDONISME SARL无法验证这些被访问网站的内容，因此对此不承担任何责任。

浏览本网站可能会在用户计算机上安装Cookie。有关Cookie使用的更多信息，请参阅我们的《隐私政策》。

## 7. 适用法律和管辖权

任何与使用luminawallet.org网站或Lumina Wallet应用程序相关的争议均受法国法律管辖。除法律不允许的情况外，巴黎（法国）主管法院拥有专属管辖权。

## 8. 消费者调解

有关消费者调解的具体安排目前正在进行法律审核。如需提出投诉，请联系 contact@luminawallet.org。本条款将在专业人士审查后更新。

> 本翻译仅供参考。如出现解释分歧，以法文版本为准。
`,
  },

  politiqueConfidentialite: {
    title: "隐私声明",
    seoTitle: "隐私声明 | Lumina Wallet",
    seoDescription: "Lumina Wallet 隐私声明。了解我们如何收集和处理您的个人数据。",
    body: `本隐私声明（“声明”）描述了 Lumina Wallet（“Lumina Wallet”、“我们”、“我方”、“我们的”、“我公司”）如何通过我们的网站 (https://luminawallet.org/) 和应用程序或其他服务（统称为我们的“服务”）收集和处理您的个人数据（“您”、“您的”）。此外，我们还可能在适用的情况下为特定目的处理您的个人数据，例如处理您的求职申请或管理您的雇佣关系。通过使用我们的服务或与我们互动，即表示您同意本隐私声明中所述的个人数据的收集、存储、处理和传输。

本隐私声明与我们的使用条款、任何商业条款或其他合同文件（包括但不限于我们可能与您签订的任何协议）一并适用。

## 1. 我们与您的关系

您的隐私权和个人数据保护对我们至关重要。Lumina Wallet 致力于隐私领域的最佳实践，我们仅在为提供服务严格必要时才收集数据。

通过使用 Lumina Wallet 的服务，例如访问我们的网站、使用我们的应用程序、在社交媒体或社区论坛上互动、参与我们的线下活动（此列表并非详尽无遗），即表示您确认并接受本隐私声明中概述的使用、披露和程序。

以下各节将进一步详细说明作为数据控制者，我们如何通过 Lumina Wallet 处理您的个人数据。

## 2. 您的个人数据的收集和使用

“个人数据”是指可能识别个人身份或与可识别个人相关的任何信息。这包括您自愿提供给我们的信息、在我们提供服务的正常过程中自动收集或创建的信息，或在您联系我们时收集的信息。遵循数据最小化等隐私最佳实践，我们努力仅收集为向用户提供服务所必需的个人数据量。

### 当您使用我们的自托管钱包时

作为我们钱包应用程序的用户，无论是通过应用程序还是浏览器扩展程序，您都可以选择创建或导入钱包信息，这些信息本地存储在您的设备上。为此，我们不收集电子邮件地址或任何其他类别的个人数据。

下表列出了应用程序使用的个人数据以及处理这些信息的目的。

| 个人数据类别 | 个人数据类型 | 处理目的和法律依据 |
|---|---|---|
| **钱包信息** | 钱包私钥和公共钱包地址。请注意，钱包信息本地存储在您的设备上，由您自行保管。 | 我们处理您的钱包信息和交易信息，以提供自托管加密钱包服务，并促进、执行和管理您请求的交易。我们进行此处理的法律依据是，这对于履行您作为一方的合同至关重要。 |
| **交易信息** | 您在公共区块链上进行的过往交易信息，例如时间戳、公共钱包地址和交易金额。 | 我们处理您的交易信息，以提供自托管加密钱包服务，并促进、执行和管理您请求的交易。我们进行此处理的法律依据是，这对于履行您作为一方的合同至关重要。 |
| **设备与使用信息** | 设备型号、操作系统、应用程序安装信息、浏览器类型和语言设置。请注意，IP 地址仅用于临时性使用，无法与任何用户的个人数据关联，并且不予保留。 | 我们使用您的设备与使用信息来提供和增强我们的服务，确保您拥有更好的用户体验。我们进行此处理的法律依据是，这对于实现我们改进服务和增强用户体验的合法权益是必要的。 |

### 当您访问我们的网站时

当您使用我们的网站、阅读我们的博客、请求客户支持、参与我们的社区论坛或活动时，您可能会提供个人数据。请注意，我们不会为此目的索取您的钱包信息。

| 个人数据类别 | 个人数据类型 | 处理目的和法律依据 |
|---|---|---|
| **联系信息** | 您在与我们网站互动期间选择提供的信息，例如电子邮件地址。 | 我们处理您的联系信息，以便就客户支持和协助目的与您沟通。我们进行此处理的法律依据是，这对于履行您作为一方的合同至关重要。 |
| **社交媒体信息** | 您在通过X、Telegram等社交媒体渠道与我们互动期间选择提供的信息。 | 我们使用您的社交媒体信息，以便在社交媒体渠道上向您更新最新公告。我们依赖您的同意来处理您与我们互动时提供的个人数据。您可以随时撤回您的同意。 |
| **个人资料信息** | 您在我们的在线社区论坛上创建个人资料时选择提供的信息，例如电子邮件、用户名、个人资料图片。 | 我们处理您的个人资料信息，以实现登录并促进社区论坛平台上的成员互动。我们进行此处理的法律依据是，这对于履行您作为一方的合同至关重要。 |
| **设备与使用信息** | 设备型号、操作系统、互联网连接数据，例如浏览器类型、应用程序版本、时区和语言设置。请注意，IP 地址仅用于临时性使用。 | 我们使用您的设备与使用信息来提供和增强我们的服务，确保您拥有更好的用户体验。我们进行此处理的法律依据是，这对于实现我们改进服务和增强用户体验的合法权益是必要的。 |

### 招聘与雇佣

如果您向我们申请职位或受雇于我们，我们将为招聘、入职、雇佣管理、遵守法律义务以及其他与雇佣相关的活动收集和处理您的个人数据。个人数据可能直接从您那里、从第三方招聘机构或从 LinkedIn 等公开来源收集。

我们为招聘和雇佣目的处理以下类别的个人数据：

1. **联系信息：** 我们将收集您的姓名、电子邮件地址和其他相关联系方式，以便就您的求职申请以及（如适用）您的雇佣情况与您沟通。
2. **教育和就业信息：** 我们收集您的简历（CV）、履历、LinkedIn 个人资料、学术证书和成绩单、就业历史以及（如相关）薪资和奖金详情。我们使用这些信息来评估您的适应性、处理您的申请、进行背景调查以及管理您的雇佣关系。

在招聘期间，我们依赖您的同意来处理您的个人数据。一旦受雇，我们将依赖履行您的合同、遵守法律义务以及我们管理雇佣关系的合法权益的必要性。如果我们无法为您提供职位，我们可能会根据我们考虑您未来角色的合法权益，将您的个人数据保留长达两年，除非您提出异议。

### 参与我们的活动

当您注册或参加我们的活动时，我们会收集一些个人数据以帮助管理您的参与。这可能包括您的姓名、联系方式、公司信息、职位、行业、位置、LinkedIn 个人资料、付款详情和账单地址。

我们使用这些信息来：

1. 处理您的活动注册和票务
2. 传达有关活动的重要更新
3. 分析参与情况以改进未来的活动

我们根据您注册时签订的协议以及我们提供和改进活动的合法权益处理您的个人数据。请注意，活动期间可能会进行摄影和摄像，用于宣传和存档目的。通过参加我们的活动，您同意 Lumina Wallet 和我们的合作伙伴可以在营销材料、社交媒体帖子或未来的活动宣传中使用您的肖像。

### 推送通知

我们可能会通过我们的应用程序向您发送可选的推送通知，以提供与您兴趣相关的警报、更新或新闻。这些通知是根据您的选择发送的，您可以随时通过应用程序内的通知设置进行管理或撤回。

### 生物识别认证（面容ID和指纹扫描）

我们提供可选的生物识别认证（如面容ID或指纹识别），作为登录钱包的安全便捷方法。如果您选择启用生物识别认证，您的生物识别数据将直接在您的设备上使用其移动操作系统内置的安全功能进行处理。您的生物识别认证信息绝不会传输到我们的服务器或任何第三方。

### 与我们的AI服务互动

当您使用涉及人工智能（“AI服务”）的服务时，例如我们的AI聊天机器人，我们会处理您在输入或反馈中提供的内容，以便我们能够响应并提供您选择使用的AI功能。

**语音输入（可选）：** 在可用情况下，您可以选择使用语音输入与AI服务互动。您的语音将实时处理以创建文本转录，然后以与任何其他基于文本的输入相同的方式进行处理。

我们基于合同履行来处理此内容，因为这是提供您请求的AI服务所必需的。为了提供这些功能，我们可能会使用根据我们指示行事的受信任第三方AI服务提供商。他们受合同和保密义务的约束，不得将您的数据用于其自身目的。

### 自动收集的个人数据

在某些情况下，当您使用我们的服务时，我们可能会根据适用法律自动收集您的个人数据。这可能包括设备、日志和使用数据，这些数据有助于我们增强您的体验、提供客户支持、提高我们网站和服务的性能，并通过检测未经授权的访问和防止欺诈来保护您的账户。

当您使用我们的自托管钱包或访问我们的网站时，您的IP地址可能会在临时性基础上进行处理。这种有限的处理仅用于（a）根据监管要求路由流量和促进服务本地化，以及（b）当您选择连接第三方平台时建立安全连接。您的隐私始终受到保护，除了这些临时性使用之外，我们不会记录、保留或以其他方式访问您的IP地址。

### 汇总和匿名化数据

我们还使用汇总和匿名化数据来改进我们的服务。这涉及分析一般使用趋势、收集反馈和进行研究，而不会识别单个用户。我们还可能与受信任的服务提供商、业务合作伙伴或其他第三方共享或披露此类汇总或匿名化数据，目的包括展示我们服务的性能、支持业务发展或为战略决策提供信息。

除非法律要求或授权，或者这样做符合您的切身利益，否则我们不会将您的个人数据用于您已获知目的不符的其他目的。
## 3. Cookie 的使用

我们使用 Cookie 和类似工具来增强您的用户体验、提供我们的服务、加强我们的营销工作以及了解客户如何使用我们的服务，以便我们进行改进。根据您所在地区适用的法律，浏览器上的 Cookie 横幅将告知您如何接受或拒绝 Cookie。

## 4. 我们如何以及为何共享您的数据

关于我们用户的信息是我们业务的重要组成部分，我们不以向他人出售用户个人数据为业。我们可能会在 Lumina Wallet 运营其业务的过程中，将个人数据传输给我们的服务提供商或第三方，因为 Lumina Wallet 的某些功能依赖于各种第三方产品和服务（统称“第三方服务”）。

第三方服务提供商仅能访问个人数据（例如您的公共钱包地址），以履行其职能、提供服务，并且不得将其用于其他目的。

我们还可能在以下人员或以下情况下共享个人数据：

- **业务转让：** 随着我们业务的持续发展，我们可能会出售或购买其他业务或服务。在此类交易中，用户信息通常是所转让的业务资产之一，但仍受任何现有隐私声明中承诺的约束。
- **法律机构：** 我们可能被法律或法院要求向相关监管、执法和/或其他主管机构披露某些信息。我们将依法披露个人数据给法律机构。
- **保护我们和他人：** 如果我们有合理理由相信访问、使用、保存或披露信息是合理必要的，以遵守任何适用法律、法规、法律程序或可执行的政府要求；与执法部门合作；执行或适用我们的使用条款及其他协议；或保护 Lumina Wallet、我们的员工、我们的用户或他人的权利、财产或安全，我们将在 Lumina Wallet 之外共享个人数据。

我们的服务和网站可能包含允许您连接各种第三方网站、应用程序和其他外部平台的链接。这些第三方平台作为独立的数据控制者，其对您个人数据的处理将受其隐私声明和政策的约束。本隐私声明不涵盖这些第三方平台的隐私实践。

## 5. 个人数据的国际传输

我们维护由我们信任的服务提供商托管的服务器，您的信息可能在您居住国以外的服务器上处理。在我们处理您居住国以外服务器上的个人数据或将其传输到第三国的情况下，我们会实施适当的技术、组织和合同保障措施，以确保您的个人数据保持受保护。这包括但不限于使用标准合同条款。

## 6. 数据安全

我们认识到信息安全是数据隐私的关键组成部分。我们致力于确保您的信息根据适用法律和我们的数据隐私政策受到保护。尽管不能保证数据传输完全安全，但我们采用一系列商业上合理的物理、技术和程序措施来保护个人数据免受未经授权的访问、使用、披露、更改或销毁。

如果您是我们的自托管钱包用户，请注意您的钱包信息和私钥存储在您的设备本地，并受您个人控制。为了保护您的钱包信息，请确保在您的设备和钱包应用程序上均启用了访问控制和密码。

## 7. 数据保留

我们保留您的个人数据，以使您能够继续使用我们的服务，只要根据本隐私声明所述的相关目的需要，或法律要求（例如出于税务和会计目的），或用于解决争议和/或法律索赔，或另行告知您。

当我们没有持续的合法业务或法律要求保留您的个人数据时，我们将删除或匿名化此类信息；如果无法做到，我们将安全存储您的个人数据并将其与任何进一步处理隔离，直到可以删除为止。

请注意，即使您从 Lumina Wallet 移动应用程序中删除您的钱包地址或将其从设备中卸载，在某些情况下，您的个人数据的删除/擦除权并非绝对。这是因为区块链是公共去中心化网络，区块链技术通常不允许删除数据。

## 8. 您拥有哪些隐私权利？

根据适用法律，您拥有多项与您的隐私和个人数据保护相关的权利。您有权请求访问、更正和删除您的个人数据，并要求数据可移植性。此外，当您同意我们将您的个人数据用于特定目的时，您可以随时撤回您的同意。

- **访问权：** 您有权获取我们持有的关于您的个人数据副本以及与其处理相关的某些信息。
- **更正权：** 您可以要求纠正不准确的个人数据，并且您还可以提供额外信息以完善您的记录。
- **删除权：** 您可以要求删除您的个人数据。请注意，为了遵守适用的法律义务，个人数据仍可能需要保留。
- **反对权：** 您可以根据与您情况相关的原因，反对处理您的个人数据。
- **限制处理权：** 在某些情况下，您有权暂时限制我们处理您的个人数据，前提是有正当理由。
- **撤回同意权：** 您有权撤回您的同意，并要求我们停止收集、使用和/或披露您的个人数据。行使此权利不影响在撤回之前基于所给予的同意进行处理的合法性。
- **可移植权：** 您还可以要求我们以结构化的方式提供您的信息，以便您可以将其发送给其他服务提供商。

我们将尽快回应。如果我们无法在 10 个工作日内回应，我们将书面通知您我们的回应时间。
## 9. 儿童

我们对儿童信息尤其敏感。我们的服务不面向儿童，且我们的用户必须年满十八 (18) 岁方可使用我们的服务。我们不会有意向任何未满 18 周岁的人士征集数据或进行营销。如果我们发现我们收集了未满 18 周岁人士的个人数据，我们将停用相关账户，并采取合理措施及时从我们的记录中删除所有此类数据。

## 10. 使用条件、通知和修订

如果您选择使用我们的服务，您的使用以及任何隐私争议均受本隐私声明和我们的使用条款的约束。我们保留随时更新和修订本声明的权利。我们将不时审查本隐私声明，以确保其符合适用法律并适应我们业务的变化。如果我们修订本隐私声明，我们将在本声明开头更新“最后更新”日期。

请定期查阅本隐私声明，以确保您了解其条款。在我们的隐私声明修订后，您继续使用我们的服务即表示您接受修订后的条款。

## 11. 隐私团队联系信息

如果您有任何与隐私相关的问题，请通过我们的在线表格联系我们。对于任何其他与钱包应用相关的查询和客户支持，请联系我们的支持团队寻求帮助，邮箱地址为 **support@luminawallet.org**。

感谢您阅读我们的隐私声明！`,
  },

  cgu: {
    title: "条款与条件",
    seoTitle: "条款与条件 | Lumina Wallet",
    seoDescription: "Lumina Wallet 条款与条件。请在使用我们的服务前阅读我们的服务条款。",
    body: `Lumina Wallet 和/或其关联公司（以下统称“我们”）通过我们的网站 luminawallet.org 提供软件服务。我们还提供相关的移动应用程序和产品（统称“服务”或“Lumina Wallet”）。在您使用我们的服务之前，请务必仔细阅读我们的服务条款（以下简称“本条款”）以及与我们的网站或移动应用程序相关的任何其他政策或通知。

## 1. 同意条款

通过使用我们的任何服务，您确认 (i) 您已阅读并理解本条款，(ii) 您同意遵守本条款，以及 (iii) 您具备接受本条款的法律资格。如果您不同意本条款或我们对其进行的任何修订，请勿使用我们的服务。

请注意，我们不提供金融或投资建议。我们提供技术服务，不就数字资产交易或操作提供任何建议。请记住，任何进行数字资产交易的决定应由您自行决定。

## 2. 隐私政策

如需了解我们如何收集、使用和披露用户信息的详情，请查阅我们的隐私声明。通过使用我们的服务，您接受并同意我们将根据我们的隐私声明条款管理您的信息（包括您提供给我们的任何个人数据）。

## 3. 条款或服务的更新

我们保留随时全权决定更新或修改本条款的权利。如果我们进行更新或修改，我们将通过在我们的网站、移动应用程序上发布修订后的条款或通过我们认为合理的其他通信方式通知您。此类修订后的条款一经发布将立即生效，除非另有说明。

您应定期查看我们的网站，以了解任何此类变更，并决定是否接受本条款的修订版本。如果您在本条款的任何更新或修改后继续使用 Lumina Wallet，则您应被视为已接受修订后的条款。如果您不同意本条款或本条款的任何更新或修改，您必须停止访问或使用我们的服务。我们的服务会随时间不断发展，我们可能随时且无需事先通知，全权决定更改或终止全部或部分服务。

## 4. 资格

使用 Lumina Wallet 的资格：

- 您必须年满十八 (18) 周岁，并具备签订本条款的法律行为能力。
- 如果您代表法律实体使用我们的服务，您进一步声明并保证该法律实体根据其组织所在司法管辖区的适用法律合法设立并有效存续；并且您已获得该法律实体的正式授权，代表其行事。
- 您不得位于或作为居民、国民或根据任何受美国全面制裁的司法管辖区的法律设立的实体，包括但不限于古巴、伊朗、朝鲜、叙利亚以及乌克兰的克里米亚、顿涅茨克和卢甘斯克地区。
- 您目前不得在美国政府（包括美国财政部外国资产控制办公室（“OFAC”）的特别指定国民和被封锁人员名单及外国制裁规避者名单，以及美国商务部工业与安全局（“BIS”）的实体名单）、联合国安理会、英国政府、欧盟或其成员国，或任何其他相关制裁机构维护的任何被禁止或受限制人员名单上。
- 您只能在您的司法管辖区法律允许的情况下使用我们的服务。为免生疑问，如果您位于或作为任何州、国家、领土或其他司法管辖区的公民或居民，且在该司法管辖区使用我们的服务将是非法或以其他方式违反任何适用法律，则您不得使用我们的服务。

请确保本条款符合所有适用于您的法律、法规和规章。您同意您仅使用合法获得的且合法属于您的资金来使用我们的服务。通过使用 Lumina Wallet，您声明并保证您符合我们在本条款中列出的所有资格要求。

尽管有上述条件，我们保留全权酌情禁止特定个人访问或使用 Lumina Wallet 的权利。此外，请注意，我们保留根据相关法律、法规和公司政策随时修改我们的资格标准的权利。

## 5. 服务

Lumina Wallet 作为一种非托管数字钱包软件，旨在用于加密货币、虚拟商品和 NFT（统称“数字资产”）等数字资产。这意味着您，且只有您，对您的数字资产和私钥拥有完全的控制权和责任，从而自主授权从您的钱包地址进行的交易。

请充分了解，由于 Lumina Wallet 作为非托管钱包软件运行，所有相关活动和潜在损失风险始终完全由您管理。Lumina Wallet 使您能够：

- 生成钱包地址和相关私钥，使您能够发送和接收各种数字资产；
- 通过移动应用程序内置的网页浏览器探索和使用第三方去中心化应用（“DApp”）和第三方去中心化交易所（“DEX”）；
- 利用独立第三方服务提供商提供的 DApp 功能进行数字资产的兑换或交易；
- 通过质押服务（“质押服务”）在第三方“权益证明”网络中部署特定数字资产；
- 获取由独立第三方服务提供商提供的数字资产价格信息；以及
- 将数字资产交易数据广播到 Lumina Wallet 支持的各种区块链网络，从而无需在您的本地设备上下载或安装相应的区块链软件。

请记住，您使用 Lumina Wallet 的功能和服务，即表示您接受与数字资产管理和交易活动相关的风险，包括网络可变性、网络安全威胁和市场波动性。
## 6. 钱包地址、私钥和备份功能

钱包相关信息的加密备份可以存储在合格设备上。钱包地址与私钥相关联；它们共同允许授权数字资产从该钱包地址转入和转出。您对私钥和与您的钱包相关的任何助记词（“密语”）的保管和安全负全权责任。

务必保护您钱包地址、密语和私钥的访问信息。同样重要的是备份您的私钥、备份短语或密码。未能如此可能导致失去对您钱包中数字资产的控制权。请注意，我们不会获取或保留您的钱包密码、加密私钥、未加密私钥或与您钱包相关的密语。此外，如果您忘记了主密码，我们无法为您的钱包生成替代密码。

如果您没有安全地保存钱包中任何私钥和钱包地址对的备份，请记住与此类钱包地址相关的所有数字资产都将无法访问。因此，如果您因任何原因无法访问您的钱包，包括但不限于未能保护您的钱包地址、密语和私钥信息，我们明确声明不承担任何责任。

保护您的数字资产需要您充分的谨慎和警觉。Lumina Wallet 的运营基于以下原则：您充分认识到数字资产的重要性，并将采取必要措施保护它们。您同意对您在 Lumina Wallet 内执行的任何行为全权负责，并承认数字资产管理相关的风险。

## 7. DApps 和 DEX 的使用

当访问或使用去中心化应用程序 (DApps) 或去中心化交易所 (DEX) 时，包括但不限于我们服务中的 DApp 功能（例如“交易/兑换数字资产”功能），您需要理解并同意以下条款：

- Lumina Wallet 不会控制、认可您参与或使用 DApps 或 DEX 的行为，也不对此承担责任。Lumina Wallet 对您使用 DApps 或 DEX 不承担任何责任或义务，包括但不限于任何有争议或导致损失的交易。
- 您每天可以通过 DEX 交易的金额受第三方智能合约开发者设定的规则和限制约束。Lumina Wallet 不控制这些限制，也不负责执行它们。
- 区块链上的所有交易都是最终的，不可逆转。这意味着通过 DApps 或 DEX 进行的任何交易完全由您控制并承担责任。您对与这些交易相关的任何问题（包括但不限于转账到错误地址或所选节点服务器出现问题）的结果承担全部责任。
- 使用 DApps 或 DEX 可能会产生与第三方智能合约相关的处理费或服务费。这些费用由第三方开发者决定，不受 Lumina Wallet 控制。用户在进行任何交易前应查阅第三方服务提供商提供的费用信息。Lumina Wallet 上显示的任何关于这些费用的信息仅供参考。Lumina Wallet 无法保证此信息的准确性、相关性、可靠性、完整性或适用性，对因您使用此信息而导致的任何直接或间接损失或损害概不负责。
- Lumina Wallet 保留将来自行决定收取费用的权利。任何费用更新将适用于更新后的费用生效后进行的交易。用户将通过合理方式收到此类变更的通知，包括在我们网站或移动应用程序上的更新。

通过 Lumina Wallet 使用 DApps 和 DEX，即表示您承认并接受这些相关风险和潜在费用。Lumina Wallet 致力于创建严格遵守法律标准和法规的用户友好环境。同意这些条款，您将增强我们对安全性、透明度和用户赋能的承诺。

## 8. 质押服务的使用

当您访问或使用质押服务时，您将与第三方提供商合作，该提供商将质押特定数字资产（“质押数字资产”）以验证相关区块链网络上的交易。成功的验证可能会产生网络发放的奖励（“质押奖励”）。

使用质押服务时，您承认并同意以下条款：

- Lumina Wallet 不控制或承担您使用质押服务的责任。我们明确声明对您使用质押服务可能出现的任何问题或损失（包括质押数字资产的任何损失、未能获得质押奖励或在此过程中产生的费用）概不负责。
- Lumina Wallet 无法保证不间断的质押操作。服务中断可能由于许多我们无法控制的因素而发生，例如代码库更新、网络协议变更、第三方提供商的行为或网络拥堵。
- Lumina Wallet 无法确保任何特定数字资产的质押或持续质押。质押某些数字资产的可行性基于各自区块链网络的规则和第三方质押服务提供商的条款和条件。
- Lumina Wallet 对相关区块链网络提供的质押奖励不承担任何控制或责任。关于质押奖励分配的决定，包括频率和数量，完全由各自网络决定，而非 Lumina Wallet。
- Lumina Wallet 不提供关于任何特定数字资产或质押服务的潜在价值或适用性的建议或预测。任何使用质押服务的决定均由您自行做出，Lumina Wallet 对此不承担任何责任。
- Lumina Wallet 绝不会托管您的任何奖励或资产，对 Lumina Wallet 可能行使您委托的验证权的任何权益证明网络不具有控制权。
- Lumina Wallet 不保证您将收到质押奖励或任何特定的质押奖励率。奖励的成功转移受权益证明网络的约束，不在 Lumina Wallet 的控制之下。
- 质押服务按“原样”提供。Lumina Wallet 对任何支持的权益证明（POS）网络未能转移奖励或因诸如转账到错误钱包地址或“罚没”（网络对恶意行为或未能验证交易施加的惩罚）等其他风险而导致的奖励损失概不负责。
- Lumina Wallet 不保证质押服务不间断或无错误运行，也不确保其将纠正所有缺陷或防止由第三方或未经授权的第三方访问引起的中断。

选择使用质押服务即表示您承认这些条件。我们保留随时修改本节的权利，恕不另行通知。您有责任定期查阅本节的任何修订。您继续使用质押服务即表示您接受这些条款及其任何修订。
## 9. 使用支持的信用卡或借记卡购买数字资产

如果您选择使用 Lumina Wallet 通过信用卡或借记卡购买数字资产，所选金额将由第三方实体转换为适用的数字资产并记入您的钱包。在此过程中，请务必承认并同意：

1.  Lumina Wallet 不对您使用此第三方服务承担任何责任，也不对此承担任何相关责任。对于在此过程中发生的任何损失，Lumina Wallet 概不负责；
2.  使用此服务时，您受特定第三方服务提供商制定的任何条款和条件的约束。Lumina Wallet 对这些条款没有影响，并且在发生任何争议时不能代表您进行干预；
3.  一旦您的请求提交，Lumina Wallet 无权或无力修改、撤销或取消任何转换请求。交易完全超出 Lumina Wallet 的控制范围；
4.  Lumina Wallet 不对所涉第三方服务提供商提供的汇率承担任何责任。这包括交易后可能发生的任何汇率波动；
5.  Lumina Wallet 不承担相关第三方服务提供商或您的银行或信用卡发卡机构施加的任何费用。交易过程中产生的任何额外费用完全由您承担。

通过选择通过 Lumina Wallet 购买数字资产，您承认这些条款并同意承担与此类交易相关的所有风险。

## 10. 数字资产交易

所有拟议的数字资产交易若要生效，必须在相应数字资产的公共区块链上进行验证和记录。这些网络是去中心化和点对点的，由独立的第三方支持，不属于 Lumina Wallet 的所有、控制或运营。

Lumina Wallet 对这些区块链网络没有控制权，因此无法保证您通过我们的服务提交的任何交易详情的确认和执行。选择使用 Lumina Wallet，您必须承认并同意以下事项：

1.  Lumina Wallet 无法取消或修改您的交易；
2.  区块链网络可能延迟或未能完成您提交的交易详情；
3.  Lumina Wallet 不存储、传输或接收数字资产。所有相关操作完全在适用区块链协议的框架内进行；
4.  任何与数字资产相关的转账都在适用的区块链网络上处理，而不是在 Lumina Wallet 拥有或运营的网络上处理，因此，Lumina Wallet 不能保证任何数字资产的所有权或权利的转让。

通过使用 Lumina Wallet 的服务，您接受与交易过程和数字资产的波动性相关的所有固有风险。

## 11. 用户提供信息的准确性

您声明并保证您通过服务提供的任何信息都是精确和全面的。您接受并理解，对于您在通过服务发起的任何数字资产交易中出现的任何错误或遗漏，我们不承担任何责任。为避免潜在问题，我们强烈建议您在发起数字资产转账之前仔细审查您的交易详情。

## 12. 钱包注册与安全

要使用 Lumina Wallet，您需要导入现有钱包或创建一个新钱包。创建钱包后，将为您生成一个私钥。如果您的私钥被未经授权使用或发生与您的钱包相关的任何其他安全漏洞，您同意立即通知我们。

但是，您理解并同意，使用我们服务相关的所有风险均由您承担，并且您将对维护您的私钥的机密性和安全性负全部责任。为避免失去对您钱包的访问权限或控制权，我们强烈建议您实施预防措施：

a. 生成一个独一无二的强密码，且未在其他地方使用；
b. 避免在线以明文形式或在不安全的物理位置存储您的私钥和助记词（Secret Phrase）；
c. 限制对您的设备和钱包的访问；
d. 确保您的设备和网络免受恶意软件侵害；以及
e. 立即告知我们任何已知或可疑的钱包安全漏洞。

我们对您钱包上的活动不承担任何责任，无论这些活动是否获得您的授权。

## 13. 推送通知

通过选择接收 Lumina Wallet 的推送通知，您将收到关于 Lumina Wallet 支持的区块链网络拥堵情况以及涉及您钱包的交易完成时的提醒。如果您希望接收这些通知，您可以在“设置”菜单中激活“推送通知”。

## 14. 第三方服务与内容

我们的平台将您连接到我们的合作伙伴提供的各种服务，包括但不限于加密货币兑换（“兑换”）、质押服务、加密货币的购买和出售、以法币显示余额的服务、加密货币汇率显示、用于交换、借贷加密货币的去中心化金融应用、NFT 可视化以及 NFT 的铸造、购买和出售。请注意，我们对这些第三方服务（“第三方服务”）没有任何控制权。

您使用这些服务以及相关的资讯内容、产品或服务（“第三方内容”）纯粹是自愿的，并且对任何此类内容的依赖均由您自行承担风险。虽然本协议规范您对我们服务的使用，但您与第三方内容和服务的互动可能会受到相应的第三方提供商设定的额外条款和条件的约束。这些额外条款可能涉及独立于我们的单独费用、免责声明、风险警告和隐私政策。您的责任是理解并确认这些条款，包括这些提供商如何处理您的个人信息。

通过与第三方服务互动，您证明您已阅读、理解并同意服务提供商的条款。尽管我们努力与值得信赖的实体合作，但我们不认可或保证其产品，也不保证其服务的成功。我们否认与您使用这些第三方服务相关的任何责任。

任何与这些服务相关的争议或投诉应直接向相应的第三方提供商提出。我们不对您与这些服务互动可能引起的任何问题承担任何责任。

需要注意的是，任何提及或参考第三方产品或服务并不表示我们认可或批准。我们保留自行决定修改或撤销任何第三方服务可用性的权利。

您可以选择接收来自第三方的推送通知。要接收这些通知，您必须明确同意，因为它们不会在您的设备上自动启用。

我们不确保通过这些通知提供的第三方内容的有效性，包括但不限于有关代币可用性或销售的信息。

如果您在我们的钱包定义的权限范围内允许第三方访问您的账户，这并不能免除您在这些条款中详述的任何责任。您对任何访问您钱包的第三方的所有作为或不作为负全部责任。
## 15. 支付和费用

与服务或其任何方面相关的费用主要由我们的第三方合作伙伴设定，可在 luminawallet.org 和/或 Lumina Wallet 移动应用程序上查阅。这些费用可包括但不限于账户管理费、交易费、提现费、燃料费（gas fees），或我们合作实体提供的特定服务的费用。请注意，这些费用由第三方实体控制，我们既不影响也不监管这些费用的制定或修改。

我们强调，这些费用源自第三方实体，我们对这些费用的制定或调整既不控制也不影响。这些合作伙伴保留根据其酌情权独立修改其费用结构的权利。

在某些情况下，Lumina Wallet 可能会从第三方收取的此类费用中获得收入分成。然而，获得收入并不赋予我们对这些费用拥有任何控制权或决策权。

任何此类费用结构的更新或调整将及时反映在我们的网站和/或移动应用程序上。您在这些更新后继续使用我们的服务即表示您接受这些变更。我们建议用户定期查看我们的网站和移动应用程序，以了解当前适用的费用。

除非另有说明，任何新的费用信息一经发布即立即生效。您有责任随时了解当前的费用结构。

此外，必须了解第三方服务，包括区块链网络，可能会增加额外的交易处理费。这些额外费用超出我们的管辖范围和影响力。因此，我们声明不承担与第三方服务相关的任何费用责任。

### 交易费

您的虚拟货币交易可能会产生交易费，例如挖矿费，这些费用由您选择使用的虚拟货币系统或区块链网络强制收取。在发起交易之前，您有责任确保您的钱包有足够的余额和/或“燃料”（网络处理能力）以完整完成交易。

需要特别指出的是，我们对这些费用或第三方系统的费用设定机制没有任何控制或影响力。因此，对于因不当输入的交易费（例如，费用设定过低或过高）而导致的任何交易失败或经济损失，我们概不负责。这同样适用于因您的钱包地址资金或燃料不足而产生的任何问题。

为免生疑问，由于我们服务的非托管性质，我们无法访问您或任何其他人的交易。我们不管理任何交易，也不保留与任何钱包相关的任何私钥。

## 16. 税务

您通过我们的服务进行交易的税务义务完全由您负责。您需要确定是否有任何税费适用于您的交易。此外，您有责任向相关税务机关申报和提交正确的税额。

我们明确声明，我们的职责不包括确定您的交易是否适用税费。我们不从事任何与数字资产相关交易产生的税款的征收、报告、代扣代缴或汇出业务。因此，您通过我们的服务进行交易所产生的任何税务义务是您与适用税务机关之间的问题。

## 17. 知识产权

### 许可

在您同意并遵守本条款的前提下，我们授予您一项非独家、不可再许可、不可转让的许可，以严格用于您个人或内部商业用途使用 Lumina Wallet。除非本条款中另有明确规定，您被禁止：

a. 复制、修改、改编 Lumina Wallet 的任何部分或创作其衍生作品；
b. 租赁、分发、销售、再许可、转让或允许他人访问 Lumina Wallet；
c. 为任何第三方利益使用 Lumina Wallet；
d. 未经我们事先书面批准，将 Lumina Wallet 集成到您向第三方提供的任何产品或服务中；
e. 规避 Lumina Wallet 中旨在限制您使用的机制；
f. 进行逆向工程、反汇编、反编译、翻译，或试图提取或获取 Lumina Wallet 的源代码，包括图像和文本、底层概念、算法、文件格式或非公开API，除非法律明确允许（在此类行为前需提前通知我们）；
g. 删除或遮盖 Lumina Wallet 中集成的任何专有或其他通知；
h. 将 Lumina Wallet 用于竞争分析目的或开发竞争产品。

### 反馈

您偶尔可能会选择向我们提供反馈意见。我们保留自由使用、复制、披露、许可、分发和利用任何与 Lumina Wallet 相关的反馈的权利，以任何方式进行，且无需承担任何义务、支付版税，或受到知识产权或其他限制。任何反馈均不被视为您的保密信息，并且本协议中没有任何限制我们独立使用、开发、评估或营销产品或服务（无论是否包含您的反馈）的权利。

### 开源

Lumina Wallet 在 GPL 开源许可下运行。Lumina Wallet 当前软件的详细信息可在 https://github.com/LuminaWallet 查阅。由于软件开发由社区在开源精神下主导，因此可供任何人访问、使用和共享（以修改或未修改的形式）。请注意，GPL 作为一种“著作权开放”（copyleft）许可，这意味着任何衍生作品必须在与父软件相同的许可条件下分发。

### 内容

Lumina Wallet 可能包含受版权保护的材料和商标，包括但不限于文本和图形内容（“内容”），受版权法、已注册和未注册商标以及其他知识产权的保护。除非另有明确说明，我们独家保留内容的所有权。您使用 Lumina Wallet 不会授予您对内容的任何权利、所有权或权益。您同意您将承诺不复制、再现、修改、重新发布、上传、张贴、传输、分发、收集、销售、许可、创作衍生作品或利用内容（全部或部分），无论采用何种方法。

### NFT 内容许可

Lumina Wallet 可能有助于存储非同质化代币（“NFT”）。您声明您拥有与 NFT 相关联的内容（“NFT 内容”）的合法知识产权或授权访问权，因此您可以在 Lumina Wallet 上存储 NFT。除本协议中明确授予的权利外，您保留在 Lumina Wallet 上存储的 NFT 内容的所有权利。

通过使用 Lumina Wallet，您允许我们获得许可，以访问、使用、托管、缓存、存储、复制、传输、显示、发布、分发、改编和修改（出于技术目的，例如跨各种设备的兼容性）NFT 内容，通过任何媒体或分发方法（现有或未来开发），以满足 Lumina Wallet 服务的需求。

由于我们不干涉所存储的 NFT 及其相关内容，我们免除因第三方知识产权侵权而产生的任何责任。对所有 NFT 相关活动进行必要的尽职调查是您的唯一责任，并且您承认我们不指导或认可与 NFT 相关的任何互动或交易。
## 18. 您对 Lumina Wallet 的使用

您同意并保证您对我们服务的使用将完全遵守所有适用法律。这包括与您的使用相关的任何地方、省、州、联邦、国家或国际法律。您承诺不将我们的服务用于资助、支持或参与任何非法活动，包括但不限于违禁贸易、非法赌博、欺诈、洗钱或恐怖活动。

本协议明确规定，如果发现您违反本条款和/或任何适用法律或监管要求（例如《银行保密法》），我们将保留本条款和法律规定的所有权利和补救措施，并将对您采取一切必要措施。

此外，您同意：

1.  不鼓励或诱导任何第三方参与本节禁止的任何活动。
2.  未经许可，不得冒充他人，或授权或试图授权其他用户的钱包。此外，不得以任何可能干扰、中断、负面影响或阻碍其他用户充分使用我们服务的方式使用我们的服务。
3.  不通过 Lumina Wallet 分发任何病毒或其他有害计算机代码。
4.  不执行任何可能对我方或我方任何第三方提供商的基础设施造成不合理或过大负担的行为。
5.  不进行逆向工程，也不规避或试图规避我们可能用于阻止或限制访问服务的任何措施。
6.  尊重、不侵犯、不盗用、不侵犯 Lumina Wallet、我们的用户或其他方的权利，包括隐私权、肖像权、知识产权或任何其他专有权利。

尽管我们没有义务监控任何用户内容，但如果您违反本条款，我们保留随时、出于任何原因，在不通知的情况下采取任何行动的完全酌情权。任何未经本条款明确授权、且未事先获得我们书面同意的 Lumina Wallet 使用行为均被严格禁止，并将导致您使用 Lumina Wallet 的许可立即终止，恕不另行通知。

## 19. 责任限制与免责声明

您确认并接受 Lumina Wallet 无法控制，也无义务就以下事项采取行动：(i) 您在使用服务期间处理数字资产时可能出现的故障、中断、错误或延迟；(ii) 硬件、软件和互联网连接故障的可能性；(iii) 在支持 Lumina Wallet 的软件中引入或发现恶意软件的风险；(iv) 未经授权的第三方访问您的钱包信息（包括但不限于您的钱包地址、私钥和助记词）的可能性；以及 (v) 相关区块链网络中未知漏洞或不可预见变化的风险。

您同意使我们免受损害，并解除我们因以下原因造成的任何损失、损害或索赔的所有责任：(a) 用户错误，例如忘记密码、交易构建错误或数字资产地址输入错误；(b) 服务器故障或数据丢失；(c) 未经授权访问 Lumina Wallet 应用程序；(d) Lumina Wallet 软件中的漏洞或其他故障；以及 (e) 未经授权的第三方活动，包括但不限于利用病毒、网络钓鱼、暴力破解或针对 Lumina Wallet 的其他潜在攻击向量。

### 责任限制

在适用法律允许的最大范围内，在任何情况下，我们、我们的关联公司、或我们的任何各自股东、成员、董事、高级职员、雇员、律师、代理人、代表、供应商或承包商均不对因您访问或使用服务而产生的任何直接损害或附带、间接、特殊、惩罚性、后果性或任何类似的损害或责任（包括但不限于数据、信息、收入、利润或其他业务或财务利益损失的损害）承担责任，无论其基于合同、侵权、过失、法规、严格责任或其他理论，即使我们已被告知发生此类损害的可能性。

某些司法管辖区不允许排除或限制对后果性或附带性损害的责任，因此上述限制可能不适用于您。在任何情况下，我们对您的所有损害（除适用法律在涉及人身伤害的案件中可能要求的以外）的责任，均不得超过一百美元（$USD100.00）或其在适用司法管辖区当地货币中的等值金额。

### 免责声明

LUMINA WALLET 按“现状”和“现有”提供，不附带任何形式的保证。在法律允许的最大范围内，我们否认所有与服务和底层软件或信息、内容或服务的任何方面相关的明示或暗示的陈述和保证，无论其由我们提供或拥有，或由任何第三方提供，或包含在任何第三方材料中或可从我们的网站或服务访问或链接到的任何第三方网站上，包括但不限于适销性、特定用途适用性、所有权、不侵权、无计算机病毒的保证，以及因交易过程、履行过程或贸易惯例而产生的任何默示保证，所有这些均在此明确否认。

## 20. 赔偿

在适用法律允许的范围内，您同意就因以下原因产生的所有索赔、损害、义务、损失、责任、侵权、成本或债务以及费用（包括但不限于律师费）为我们、我们的关联公司以及我们各自的股东、成员、董事、高级职员、雇员、律师、代理人、代表、供应商和承包商进行抗辩、赔偿并使其免受损害：(a) 您对服务的使用和访问；(b) 您向我们提供的任何与 Lumina Wallet 相关的反馈或提交内容；(c) 违反任何第三方内容；(d) 您违反本条款；或 (e) 您违反任何法律、规则或法规，或任何第三方的权利。
## 21. 索赔期限限制

您同意，因您与我们的关系产生或与之相关的任何索赔，必须在该索赔产生后一年内提出，否则，您的索赔将永久失效。

## 22. 终止

若您使用 Lumina Wallet 的许可被终止，您在本协议项下的义务仍将继续。终止后，您能否访问您钱包中的资金将取决于您能否访问您钱包地址和私钥的备份。

## 23. 服务中止

我们可根据我们的全权酌情决定，无需向您收取费用，无论是否事先通知，随时修改或暂时或永久中止我们的任何部分服务。您全权负责在服务之外存储您在钱包中维护的任何钱包地址和私钥对的备份。

维护与您的钱包关联的任何钱包地址和私钥对的外部备份将允许您在您的钱包安全地所在的区块链网络上访问。此类备份将允许您随时完全恢复您的钱包，而无需支付费用或损失您的数字资产。如果您未在服务之外维护您的钱包数据备份，您将无法访问与您的钱包关联的数字资产。如果我们中止所有或任何部分服务，Lumina Wallet 不对任何数字资产的损失负责或承担责任。

## 24. 不弃权

我们未能或延迟行使本协议项下的任何权利、权力或特权，不构成弃权；任何单一或部分行使任何权利、权力或特权，也不排除其任何其他或进一步的行使。任何此类权利或条款的弃权仅在书面形式并经我们正式授权的代表签署后方可生效。除非本协议中另有明确规定，任何一方行使其在本协议项下的任何补救措施，不影响其在本协议项下或根据其他规定享有的其他补救措施。

## 25. 可分割性

如果本协议的任何部分被证明是无效、作废或因任何原因不可执行的，则该条款应被视为可分割的，并在必要的最少范围内予以限制或排除。该条款的限制或排除不应影响或损害该条款、子句或规定的任何剩余部分以及本条款中的任何其他条款、子句或规定的有效性或可执行性。

## 26. 管辖法律、集体诉讼豁免与仲裁协议

### (i) 管辖法律

除适用法律另有规定或提供替代方案的情形外，本条款，包括本协议中的仲裁协议，应受法国法律管辖并根据其解释。

### (ii) 集体诉讼豁免

除适用法律另有要求或提供替代选择的情形外，您和 Lumina Wallet 同意，根据上述关于索赔通知和争议解决期限的条款，任何索赔必须通过由国际商会 (ICC) 监督的强制性、最终且具有约束力的个体（非集体）仲裁解决，并符合其现行规则，这些规则应被视为通过援引并入本条款。

### (iii) 仲裁协议

仲裁地约定为法国巴黎。仲裁庭将由一名（1）仲裁员组成，该仲裁员将根据 ICC 规则任命。仲裁语言为法语或英语。您和 Lumina Wallet 进一步同意，仲裁员将独家拥有裁决其管辖权的权力，这包括有关仲裁协议的存在、范围或有效性，或任何索赔的可仲裁性的任何异议。本条款中详述的仲裁规定将在本条款终止后仍然有效。

**提交期限：** 要对 Lumina Wallet 提起任何仲裁，必须在提出索赔的用户首次识别或应合理发现导致索赔的被指控行为、不作为或违约之日起一（1）年内，根据 ICC 规则提交并送达仲裁通知（“时效期限”）。如果未在该时效期限内就索赔向 Lumina Wallet 提交并送达仲裁通知，则用户将无任何追索权或救济。

**通知：** 如果 Lumina Wallet 对您提起仲裁，它将向您提供的电子邮件地址或邮政地址发出通知。您同意，发送到此电子邮件或邮政地址的任何通知将视为所有目的（包括与送达充分性相关的决定）均已足够。您有义务保持在 Lumina Wallet 存档的电子邮件地址和/或邮政地址为最新且准确。

## 27. 不可抗力

我们不对因超出我们合理控制范围的任何原因或条件直接或间接导致的任何延迟、履约失败或服务中断负责，包括但不限于：任何因天灾、民事或军事当局的行为、恐怖主义行为、民事或工业骚乱、封锁、禁运、战争、罢工或其他劳资纠纷、火灾、地震、风暴或其他自然事件、电力电信或互联网服务或网络提供商服务中断、硬件设备和/或软件故障或其他公用事业故障、智能合约漏洞或弱点、技术变更、利率或其他货币条件变化，以及为免生疑问，任何区块链相关协议的变更、其他灾难或任何其他超出我们合理控制范围的事件，并且不应影响任何剩余条款的有效性和可执行性。

## 28. 转让

您同意，我们可以在未经您任何通知或同意的情况下，转让我们的任何权利和/或转移、分包或委托我们在本条款项下的任何义务。本条款将对双方及其继承人和允许的受让人具有约束力并为其利益而存在。您对本条款的同意是针对您个人的，您不得将其转让或让与任何第三方。
## 29. 无第三方受益人

您同意，除本条款另有明确规定外，本条款不设第三方受益人。

## 30. 完整协议

本协议阐明了双方就本协议标的达成的全部谅解和协议，并取代双方之间所有先前任何形式和性质的讨论、协议和谅解（包括但不限于本条款的任何先前版本）。除上述规定外，对本条款的任何修改必须以书面形式进行，并须经双方签署。

## 31. 通知

我们根据本条款提供的任何通知或其他通讯，包括关于本条款修改的通知，将通过在服务上发布和/或通过其他电子通讯方式发出。您同意并允许以电子方式接收我们与您的账户和您使用服务相关的所有通讯、协议、文件、通知和披露。

## 32. 问题或意见

如果您对本条款、您根据本条款产生的权利和义务和/或您使用 Lumina Wallet 及我们的服务有任何疑问，或有任何其他事项，请通过我们的联系页面发送邮件至 **support@luminawallet.org**。`,
  },
};

export default zh;
